import {observer} from 'mobx-react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import RequestDetails from './RequestDetails';

const RequestsPage = observer(() => {
  return (
    <Router basename='/time_off'>
      <Switch>
        <Route path='/requests/:id/:backPath?' render={({match}) => <RequestDetails match={match}/>} />
      </Switch>
    </Router>
  );
});

export default RequestsPage;
